import * as React from 'react'
import { toast, ToastOptions } from 'react-toastify'
import clsx from 'clsx'

import styles from './Notice.module.scss'

export type NoticeProps = {
	title?: React.ReactNode
	message?: React.ReactNode
	titleClassName?: string
	messageClassName?: string
	type?: 'error' | 'info' | 'success'
	props?: ToastOptions
}

export const notice = ({
	title,
	message,
	titleClassName,
	messageClassName,
	type = 'error',
	props,
}: NoticeProps) => {
	const themeClassnames = {
		[styles.error]: type === 'error',
		[styles.info]: type === 'info',
		[styles.success]: type === 'success',
	}

	return toast(
		<div className={clsx(styles.content, themeClassnames)}>
			{title && <div className={clsx(styles.title, themeClassnames, titleClassName)}>{title}</div>}
			{message && <div className={clsx(styles.small, messageClassName)}>{message}</div>}
		</div>,
		{
			...props,
			className: clsx(themeClassnames),
			type: 'default',
		}
	)
}
